import React from "react";

import chevronDown from "@iconify/icons-bi/chevron-down";
import { Icon } from "@iconify/react/dist/offline";
import { type Theme } from "@mui/material/styles";

// Custom icon component for MUI Select
const ChevronDownIcon = (props: { className?: string }) => (
  <Icon icon={chevronDown} width={20} height={20} className={props.className} />
);

export default function Select(theme: Theme): any {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ChevronDownIcon,
      },

      styleOverrides: {
        root: {
          height: theme.spacing(7),
          borderRadius: "3px",
          backgroundColor: theme.palette.background.default,
        },
      },
    },
  };
}
